import Checkbox from '@/components/atoms/Checkbox';
import type { OverviewCage } from '@/domain/client';

import type { HistoricalSelection } from '../useHistoricalSelection';

export interface LocationOverviewHistoricalCellProps {
    cage: OverviewCage;
    selection: HistoricalSelection;
}

/** Ticks the pen into the batch; nothing is saved until the batch is confirmed. */
export default function LocationOverviewHistoricalCell(props: LocationOverviewHistoricalCellProps) {
    const { cage, selection } = props;

    return (
        <Checkbox
            disabled={selection.isSubmitting}
            checked={selection.isChecked(cage)}
            onCheckedChange={() => selection.toggle(cage)}
        />
    );
}
